// Copyright (c) 2016 Deere & Company

import DateCellRenderer from '../../shared/report-cell-renderers/date-cell-renderer';
import PinCellRenderer from '../../shared/report-cell-renderers/pin-cell-renderer';
import RegistrationFormCellRenderer from '../../shared/report-cell-renderers/registration-form-cell-renderer';
import classNames from '../../shared/constants/ag-grid-class-names';
import dateFilterParams from '../../shared/constants/date-filter-params';
import {translate} from '../../../shared/services/translation-service';

const smartFormValueGetter = params => params.data.registrationForm ? params.data.id : null;

const getRegistrationFormColumn = userPrivacy =>
    userPrivacy.registrationFormNotAllowed ?
        null : {
            cellClass: classNames.cellClassName,
            cellRendererFramework: RegistrationFormCellRenderer,
            colId: 'id',
            headerClass: classNames.headerClassName,
            headerName: translate('REGISTRATION_FORM'),
            suppressFilter: true,
            valueGetter: smartFormValueGetter,
            width: 200
        };

export function getRegistrationsReviewColumnDefinitions(userPrivacy) {

    return [
        {
            cellClass: classNames.cellClassName,
            colId: 'registrationStatus',
            field: 'registrationStatus',
            headerClass: classNames.headerClassName,
            headerName: translate('REGISTRATION_STATUS'),
            width: 175
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'registrationDate',
            field: 'registrationDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('REGISTERED'),
            width: 110
        },
        {
            cellClass: classNames.cellLeftClassName,
            cellRendererFramework: PinCellRenderer,
            colId: 'pin',
            field: 'pin',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('PIN'),
            width: 190
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'accountNumber',
            field: 'accountNumber',
            headerClass: classNames.headerClassName,
            headerName: translate('ACCOUNT'),
            width: 150
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'accountAddress',
            field: 'accountAddress',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('LOCATION'),
            width: 200
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'statusIndicator',
            field: 'statusIndicator',
            headerClass: classNames.headerClassName,
            headerName: translate('REGISTRATION_STATUS'),
            width: 175
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'deliveryDate',
            field: 'deliveryDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('DELIVERED'),
            width: 110
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'expectedDateOfFirstUse',
            field: 'expectedDateOfFirstUse',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('FIRST_USE'),
            width: 120
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'comments',
            field: 'comments',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('COMMENTS'),
            width: 300
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'customerName',
            field: 'customerName',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('CUSTOMER'),
            width: 140
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'street1',
            field: 'street1',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('STREET_1'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'street2',
            field: 'street2',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('STREET_2'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'postalCode',
            field: 'postalCode',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('POSTAL_CODE'),
            width: 130
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'phone',
            field: 'phone',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('PHONE'),
            width: 160
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'mobilePhone',
            field: 'mobilePhone',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('MOBILE_PHONE'),
            width: 160
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'email',
            field: 'email',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('EMAIL'),
            width: 160
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'city',
            field: 'city',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('CITY'),
            width: 120
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'region',
            field: 'region',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('REGION'),
            width: 100
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'country',
            field: 'country',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('COUNTRY'),
            width: 100
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'message',
            field: 'message',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('MESSAGE'),
            width: 300
        },
        getRegistrationFormColumn(userPrivacy)
    ].filter(column => column !== null);

}



// WEBPACK FOOTER //
// ./src/reports/registrations-review/report-services/column-definitions.js